import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store/rootReducer";
import { MessageInitialState, MessageType } from "./types";

const initialState: MessageInitialState = {
  showMessage: false,
  text: "",
  type: MessageType.info,
};

const compare = createSlice({
  name: "compare",
  initialState,
  reducers: {
    setMessage(
      state,
      action: PayloadAction<{
        text: string;
        type: MessageType;
      }>
    ) {
      const { text, type } = action.payload;
      state.showMessage = true;
      state.text = text;
      state.type = type;
    },
    hideMessage(state) {
      state.showMessage = false;
      state.text = "";
    },
  },
});
export const { setMessage, hideMessage } = compare.actions;
export const selectMessage = (state: RootState) => state.message;

export default compare.reducer;
